import { createReducer, on } from '@ngrx/store';
import { ChargepointSummaryItem } from 'brain-data/model/chargepoint.model';
import { loadChargepointSummary, loadChargepointSummarySuccess, loadChargepointSummaryError, setChargepointDataFromJson } from '../actions/chargepoint.action';

export default interface ChargepointState {
  loading: boolean;
  summary: ChargepointSummaryItem[];
  error?: Error;
}

export const initialState: ChargepointState = {
  loading: false,
  summary: [],
  error: undefined,
};

export const chargepointReducer = createReducer<ChargepointState>(
  initialState,
  on(
    loadChargepointSummary,
    (state): ChargepointState => ({
      ...state,
      loading: true,
      error: undefined,
    }),
  ),
  on(
    loadChargepointSummarySuccess,
    (state, { summary }): ChargepointState => ({
      ...state,
      summary,
      loading: false,
      error: undefined,
    }),
  ),
  on(
    loadChargepointSummaryError,
    (state, { error }): ChargepointState => ({
      ...state,
      loading: false,
      error,
      summary: [],
    }),
  ),
  on(
    setChargepointDataFromJson,
    (state, { summary }): ChargepointState => ({
      ...state,
      summary,
      loading: false,
      error: undefined,
    }),
  ),
);
